module.exports = __webpack_public_path__ + "media/images/eduardo-vazquez-0c337c2fbd86e654dc0f2bd61a7eb89c.jpg";